import { AccessCode } from 'model/AccessCode';
import { Resource } from 'model/Resource';
import { Selector } from 'reselect';
import { SurveyState } from 'store/SurveyState';

export const selectAccessCodeResource: Selector<SurveyState, Resource<AccessCode>> = (state) =>
  (state && state.accessCode) || Resource.void<AccessCode>();
